import http from "@/http";

/**
 * Управление DOM-элементами корзины без Vue.
 */
export default function initShopCartDom(store) {
    const controls = Array.from(document.querySelectorAll('[data-shop-cart-control]'));
    const highlights = Array.from(document.querySelectorAll('[data-shop-cart-highlight]'));
    const counters = Array.from(document.querySelectorAll('[data-shop-cart-count]'));
    const emptyIcons = Array.from(document.querySelectorAll('[data-shop-cart-empty-icon]'));

    if (!controls.length && !highlights.length && !counters.length && !emptyIcons.length) {
        return;
    }

    const mutationNames = ['initShopCart', 'saveCartItem', 'removeCartItem'];

    controls.forEach((control) => {
        const addBtn = control.querySelector('[data-shop-cart-add]');
        if (!addBtn) {
            return;
        }
        addBtn.addEventListener('click', () => handleAdd(control, addBtn));
    });

    syncUi();

    store.subscribe(({ type }) => {
        if (mutationNames.includes(type)) {
            syncUi();
        }
    });

    function getCartItem(control) {
        const productId = control.dataset.productId;
        const saleDateId = control.dataset.saleDateId || null;
        return store.getters.getShopCartItem(productId, saleDateId);
    }

    function handleAdd(control, addBtn) {
        if (control.dataset.loading === 'true') {
            return;
        }

        const productId = control.dataset.productId;
        const saleDateId = control.dataset.saleDateId || null;
        const quantityStep = parseInt(control.dataset.quantityStep || '1', 10);
        const existingItem = getCartItem(control);
        const targetQuantity = existingItem ? existingItem.quantity + quantityStep : quantityStep;

        control.dataset.loading = 'true';
        addBtn.disabled = true;

        http.post('shop-cart', {
            product_id: productId,
            sale_date_id: saleDateId,
            quantity: targetQuantity,
        })
            .then((res) => {
                if (res.shop_cart) {
                    store.dispatch('initShopCart', res);
                } else if (existingItem) {
                    store.dispatch('removeCartItem', existingItem);
                }
            })
            .catch((error) => {
                console.error('Ошибка добавления в корзину', error);
            })
            .finally(() => {
                delete control.dataset.loading;
                addBtn.disabled = false;
            });
    }

    function syncUi() {
        updateControls();
        updateHighlights();
        updateCounters();
    }

    function updateControls() {
        controls.forEach((control) => {
            const link = control.querySelector('[data-shop-cart-link]');
            const addBtn = control.querySelector('[data-shop-cart-add]');
            if (!link || !addBtn) {
                return;
            }
            const item = getCartItem(control);
            if (item) {
                link.classList.remove('d-none');
                addBtn.classList.add('d-none');
            } else {
                link.classList.add('d-none');
                addBtn.classList.remove('d-none');
            }
        });
    }

    function updateHighlights() {
        highlights.forEach((element) => {
            const productId = element.dataset.productId;
            const saleDateId = element.dataset.saleDateId || null;
            const highlightColor = element.dataset.highlightColor || '#a9d663';
            const item = store.getters.getShopCartItem(productId, saleDateId);
            element.style.background = item ? highlightColor : '';
        });
    }

    function updateCounters() {
        const totalItems = store.getters.getShopCartItems.length;
        counters.forEach((counter) => {
            if (totalItems > 0) {
                counter.textContent = totalItems;
                counter.classList.remove('d-none');
            } else {
                counter.classList.add('d-none');
            }
        });
        emptyIcons.forEach((icon) => {
            if (totalItems > 0) {
                icon.classList.add('d-none');
            } else {
                icon.classList.remove('d-none');
            }
        });
    }
}
